import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import _isNil from 'lodash/isNil';

// Components
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import TextWithActionLink from '../../textWithActionLink';

// Constants
import { EMPTY_PLACEHOLDER } from '../cellRenderer.constants';

// Containers
import makeCellRenderer from '../makeCellRenderer';

// Action types
import TEXT_WITH_LINK from './textWithLink.actionTypes';
var TextWithLink = /*#__PURE__*/function (_PureComponent) {
  _inherits(TextWithLink, _PureComponent);
  var _super = _createSuper(TextWithLink);
  function TextWithLink() {
    var _this;
    _classCallCheck(this, TextWithLink);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleButtonClick", function (actionType) {
      var _this$props = _this.props,
        onAction = _this$props.onAction,
        rowData = _this$props.original,
        column = _this$props.column;
      var id = column.id;
      onAction({
        type: actionType,
        payload: {
          columnId: id,
          rowData: rowData,
          column: column
        }
      });
    });
    return _this;
  }
  _createClass(TextWithLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        data = _this$props2.data,
        className = _this$props2.className,
        containerClassName = _this$props2.containerClassName,
        actionType = _this$props2.actionType,
        highlightOnHover = _this$props2.highlightOnHover;
      if (_isNil(data)) return EMPTY_PLACEHOLDER;
      return /*#__PURE__*/React.createElement(TextWithActionLink, {
        className: className,
        containerClassName: containerClassName,
        onActionClick: this.handleButtonClick,
        label: data,
        actionId: actionType,
        highlightOnHover: highlightOnHover
      });
    }
  }]);
  return TextWithLink;
}(PureComponent);
TextWithLink.propTypes = {
  data: PropTypes.string.isRequired,
  actionType: PropTypes.string,
  onAction: PropTypes.func,
  original: PropTypes.object,
  column: PropTypes.object,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  highlightOnHover: PropTypes.bool
};
TextWithLink.defaultProps = {
  onAction: _noop,
  actionType: TEXT_WITH_LINK.TEXT_CLICK,
  original: EMPTY_OBJECT,
  column: EMPTY_OBJECT,
  className: '',
  containerClassName: '',
  highlightOnHover: false
};
export default makeCellRenderer(TextWithLink);